import axios from 'axios'

export const getFinanceTags = (params) => {
  return axios.get('/finance/tags', { params })
}

export const addFinanceTag = (data) => {
  return axios.post('/finance/tags', data)
}

export const editFinanceTag = (data) => {
  return axios.put(`/finance/tags/${data.id}`, data)
}

export const getSuggestionFinanceTag = (params) => {
  return axios.get('/finance/tags/suggestionPerPage', { params })
}

export const getFinanceTag = (id, params) => {
  return axios.get(`/finance/tags/${id}`, { params })
}

export const getFinanceTagLog = ({ id, params } = {}) => {
  return axios.get(`/finance/tags/${id}/logs`, { params })
}

export const deleteFinanceTag = (id) => {
  return axios.delete(`/finance/tags/${id}`)
}

export const archiveFinanceTag = (id) => {
  return axios.patch(`/finance/tags/${id}/archive`)
}

export const unarchiveFinanceTag = (id) => {
  return axios.patch(`/finance/tags/${id}/unarchive`)
}

export const getFinanceTagRoles = (id) => {
  return axios.get(`/finance/tags/${id}/roles`)
}

export const addFinanceTagRoles = (id, data) => {
  return axios.post(`/finance/tags/${id}/roles`, data)
}

export const getFinanceTagDetail = (params, config = {}) => {
  return axios.get('/finance/tags', { params, ...config })
}

export const uploadImportFinanceTag = (data) => {
  return axios.postForm('/finance/tags/uploadImport', data)
}

export const executeImportFinanceTag = (data) => {
  return axios.post('/finance/tags/executeImport', data)
}
